import Navigationbar from "../components/Navigationbar"
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useState, useEffect } from "react";
import Footer from "../components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChessKing } from '@fortawesome/free-solid-svg-icons';
import '../Styles/button.css'
import '../Styles/Home.css'
import HomePageSlider from "../components/HomePageComponents/HomePageSlider";
import CircleDiagram from "../components/StrategiComponents/CircleDiagram";
import useCircleDiagramData from "../hooks/AccordionHooks/useCircleDiagramData";
import useFetchCompanyId from "../hooks/CompanyHooks/useFetchCompanyId";
import { useSelectedCompany } from "../contexts/SelectedCompanyContext";
import { useSelectedYear } from "../contexts/SelectedYearContext";
import SelectYear from "../components/SelectYear";
import useFetchAppointments from "../hooks/useFetchAppointments";
import useFetchMultipleAppointmentStatistics from '../hooks/useFetchMultipleAppointmentStatistics';
import LoadingComponent from "../components/LoadingComponent";
import AppointmentStatisticsCard from "../components/HomePageComponents/AppointmentStatisticsCard";
import { useAuthStatus } from "../hooks/useAuthStatus";
import AdminDropdown from "../components/AdminDropDown";
import useFetchCompanies from "../hooks/CompanyHooks/useFetchCompanies";

function Home () {
    const navigate = useNavigate()
    const { isAdmin } = useAuth();
    const currentYear = new Date().getFullYear();
    const lastYear = currentYear - 1;
    const fromLastYear = `${lastYear}-01-01`;
    const toLastYear = `${lastYear}-12-31`;
    const { loggedIn, checkingStatus } = useAuthStatus();
    const { selectedYear, setSelectedYear } = useSelectedYear();
    const { selectedCompany, setSelectedCompany, isLoading: isSelectedCompanyLoading } = useSelectedCompany();
    const { companies, isLoading: isCompaniesLoading, error } = useFetchCompanies();
    const { companyId, isLoading: isCompanyLoading, error: companyError } = useFetchCompanyId(selectedCompany);
    const { finishedTasks, totalTasks } = useCircleDiagramData(companyId, selectedYear);
    const [loadingGoodAppointments, setLoadingGoodAppointments] = useState(true);
    const [loadingBadAppointments, setLoadingBadAppointments] = useState(true);
    const [goodAppointments, setGoodAppointments] = useState([]);
    const [badAppointments, setBadAppointments] = useState([]);
    const [appointmentArgs, setAppointmentArgs] = useState({
        from: fromLastYear, 
        to: toLastYear, 
        open: false, 
        hnAppointmentId: ""
      });
    const { data: appointments, isLoading: isAppointmentsLoading, error: appointmentsError } = useFetchAppointments(
        selectedCompany, 
        appointmentArgs.hnAppointmentId, 
        appointmentArgs.from, 
        appointmentArgs.to, 
        appointmentArgs.open
    );

    const appointmentIds = appointments ? appointments.map(appointment => appointment.hnAppointmentID) : [];
    const { statistics, isLoading: isStatisticsLoading, error: statisticsError } = useFetchMultipleAppointmentStatistics(selectedCompany, appointmentIds);

    useEffect(() => {

        const currentYear = new Date().getFullYear();
        const lastYear = currentYear - 1;
        const fromLastYear = `${lastYear}-01-01`;
        const toLastYear = `${lastYear}-12-31`;
    
        setAppointmentArgs(args => ({
          ...args,
          from: fromLastYear,
          to: toLastYear
        }));
      }, []);
    
    useEffect(() => {
        if (appointments && appointmentIds) {
            const statisticsWithIds = statistics.map((stat, index) => {
                const hnAppointmentID = appointmentIds[index];
                return { ...stat, hnAppointmentID };
            });
            const combinedAppointments = statisticsWithIds.map(stat => {
                const correspondingAppointment = appointments.find(app => app.hnAppointmentID === stat.hnAppointmentID);
                const dækningsbidrag = stat.invoicedAmount - stat.costPrice;
                const percentage = stat.invoicedAmount ? (dækningsbidrag / stat.invoicedAmount) * 100 : 0;

                return {
                    ...stat,
                    dækningsbidrag,
                    percentage,
                    subject: correspondingAppointment ? correspondingAppointment.subject : 'Unknown Appointment'
                };
            });

            const newGoodAppointments = combinedAppointments
                .filter(app => app.percentage <= 40 && app.percentage >= 0)
                .sort((a, b) => b.percentage - a.percentage)
                .slice(0, 5);

            const newBadAppointments = combinedAppointments
                .filter(app => app.percentage < 0 && app.percentage >= -40)
                .sort((a, b) => a.percentage - b.percentage)
                .slice(0, 5);

            setGoodAppointments(newGoodAppointments);
            setBadAppointments(newBadAppointments);
            setLoadingGoodAppointments(false);
            setLoadingBadAppointments(false);
        }
    }, [appointments, statistics]);

    const onMonthlyreportClick = () => {
        navigate('/månedsrapport')
    }
    const onStrategiClick = () => {
        navigate('/strategi')
    }

    if (isAppointmentsLoading || !appointments || isCompanyLoading || checkingStatus) {
        return <LoadingComponent />;
    }
    if (appointmentsError || statisticsError) return <div>Error: {appointmentsError || statisticsError.e}</div>;
    return (
        <div>
        <Navigationbar/>
        {loggedIn ? (
        <div className="container home-container">
            <h1 className="main-header">
                Velkommen tilbage
            </h1>
            <HomePageSlider />
            {isAdmin && (
            <AdminDropdown
              selectedCompany={selectedCompany}
              setSelectedCompany={setSelectedCompany}
              allCompanies={companies}
              isCompanyLoading={isCompanyLoading}
            />
          )}
            <div className="custom-row mt-3">
                <div className="custom-column">
                    <div className="content-container">
                        <h3 className="sub-header">Overblik</h3>
                            <p className="d-flex justify-content-center">
                                Få det fulde overblik over din virksomhed. 
                                Baseret på data giver vi dig adgang til en fuld rapport.
                                der giver dig status på din virksomhed.
                            </p>
                    </div>
                </div>
                    <div className="custom-column">
                        <div className="content-container">   
                        <h3 className="sub-header">Din månedsrapport er klar!</h3>
                    <button onClick={onMonthlyreportClick} className="generic-ea-btn" >Se rapport</button>
                    </div>
                </div>                    
            </div>
                <div className="custom-row mt-3">
                    <div className="custom-column">
                        <div className="content-container">
                        <div className="mt-3">
                        <SelectYear selectedYear={selectedYear} setSelectedYear={setSelectedYear} handleChangeYear={setSelectedYear}></SelectYear>
                            <div>
                                <CircleDiagram totalTasks={totalTasks} finishedTasks={finishedTasks} selectedCompany={selectedCompany} />
                            </div>
                            </div>                        
                    </div>  
                        </div>
                <div className="custom-column">
                    <div className="content-container">
                    <h3 className="sub-header">Tilgå Din Strategi</h3>                     
                        <FontAwesomeIcon icon={faChessKing} size="5x" />
                                <button onClick={onStrategiClick} className="generic-ea-btn">Strategi</button>
                    </div>
                    <div className="content-container mt-4">
                    <h3 className="sub-header">Placeholder</h3>                     
                        <FontAwesomeIcon icon={faChessKing} size="5x" />
                                <button onClick={onStrategiClick} className="generic-ea-btn">Placeholder</button>
                    </div>
                </div>
                </div>
                <div className="custom-row mt-3">
            <div className="custom-column">
            <h3 className="sub-header">Gode Sager</h3>
              <div className="content-container2">
              {loadingGoodAppointments ? <LoadingComponent /> : 
                        goodAppointments.map(appointment => (
                            <AppointmentStatisticsCard key={appointment.hnAppointmentID} appointment={appointment} />
                        ))
                    }
              </div>
            </div>
            <div className="custom-column">
            <h3 className="sub-header">Dårlige sager</h3>
              <div className="content-container2">
              {loadingBadAppointments ? <LoadingComponent /> : 
                        badAppointments.map(appointment => (
                            <AppointmentStatisticsCard key={appointment.hnAppointmentID} appointment={appointment} />
                        ))
                    }
              </div>
            </div>
          </div>
        </div>) : <div className="d-flex justify-content-center"><h3 style={{fontWeight:'bold'}}>Login for at se dit dashboard</h3></div>}
        <Footer></Footer>
    </div> 
    )
}
export default Home;
